import {
  SELECT_PROJECT,
  ROLLBACK_PROJECT,
} from 'store/services/project/actionTypes';
import {
  DESELECT_TEST_SET,
  GET_TEST_SETS_FILES_REQUEST,
} from 'store/services/testSets/actionTypes';
import * as types from './actionTypes';
import initialState from './initialState';

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_TEST_SET_ENTRIES_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_TEST_SET_ENTRIES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: {
            ...state.list.data,
            items: action.payload.testSetEntries,
            count: action.payload.count,
          },
        },
      };
    case types.GET_TEST_SET_ENTRIES_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.ADD_TEST_SET_ENTRY_REQUEST:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: true,
        },
      };
    case types.ADD_TEST_SET_ENTRY_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
        },
      };
    case types.ADD_TEST_SET_ENTRY_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_TEST_SET_ENTRY_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: true,
        },
      };
    case types.UPDATE_TEST_SET_ENTRY_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: false,
        },
      };
    case types.UPDATE_TEST_SET_ENTRY_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.DELETE_TEST_SET_ENTRY_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: true,
        },
      };
    case types.DELETE_TEST_SET_ENTRY_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
        },
      };
    case types.DELETE_TEST_SET_ENTRY_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.DELETE_TEST_SET_ENTRIES_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: true,
        },
      };
    case types.DELETE_TEST_SET_ENTRIES_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
        },
        list: {
          ...state.list,
          data: {
            ...state.list.data,
            selected: [],
          },
        },
      };
    case types.DELETE_TEST_SET_ENTRIES_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_SELECTED_ENTRIES:
      return {
        ...state,
        list: {
          ...state.list,
          data: {
            ...state.list.data,
            selected: action.payload.entries,
          },
        },
      };
    case types.UPDATE_TEST_SET_ENTRIES_PAGINATION_PARAMS:
      return {
        ...state,
        list: {
          ...state.list,
          paginationOptions: action.payload.paginationOptions,
        },
      };
    case types.UPDATE_TEST_SET_ENTRIES:
      return {
        ...state,
        list: {
          ...state.list,
          data: {
            ...state.list.data,
            items: action.payload.entries,
          },
        },
      };
    case DESELECT_TEST_SET:
    case GET_TEST_SETS_FILES_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: '',
          paginationOptions: {
            page: 1,
            size: 20,
            value__icontains: '',
          },
          data: {
            items: [],
            count: 0,
          },
        },
      };
    case SELECT_PROJECT:
    case ROLLBACK_PROJECT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
